import { Button, Container, PortalLayout, Stack, Typography } from "../../design-system";
import { notPermittedContent } from "./content";

export interface NotPermittedPageProps {
  /** The one action this view offers: returns the contributor to their
   * renewal, where their saved or delegated-section answers remain
   * readable. Framed as a return, never as a retry of whichever action
   * was refused -- nothing is recorded when this view is shown. */
  onReturnToRenewal: () => void;
}

/**
 * /renewal/not-permitted (ADR-20261008-jg8z). ADR-20261016-b9hz
 * generalised this view's copy (see content.ts) to cover every refusal
 * AC-19 names, not only a rejected submission: a 403
 * `role_not_permitted_to_submit` from POST /api/portal/submission, a
 * contributor deep-linking screen 3 or screen 6 (ADR-20261015-c9zb), and
 * a contributor refused a section or endpoint outside their delegated
 * set all render this same view. Rendered in `PortalLayout` with the
 * help line (ADR-20261008-hsvr amendment 2026-10-11).
 */
export function NotPermittedPage({ onReturnToRenewal }: Readonly<NotPermittedPageProps>) {
  return (
    <PortalLayout helpLine={notPermittedContent.helpLine}>
      <Container>
        <Stack gap="lg">
          <Typography variant="heading1" as="h1">
            {notPermittedContent.heading}
          </Typography>
          <Typography variant="body">{notPermittedContent.body}</Typography>
          <Button emphasis="primary" onClick={onReturnToRenewal}>
            {notPermittedContent.returnToRenewalActionLabel}
          </Button>
        </Stack>
      </Container>
    </PortalLayout>
  );
}
